import { Data } from './data';
import { Thinning } from './thinning';
import { Irrigation } from './irrigation';
import { Carbohydrate } from './carbohydrate';
import { Speech } from './speech';

export {
  Data,
  Thinning,
  Irrigation,
  Carbohydrate,
  Speech
};



// WEBPACK FOOTER //
// ./src/providers/providers.ts